import { RequestPayload } from "appworks/model/gameplay/requests/request-payload";
import { ForceData } from "slotworks/debug/force-data";

export class ForceRequestPayload extends RequestPayload {
    constructor(public data: ForceData) {
        super();
    }
}
